import React from "react";
import { ProgressBar as UiProgressBar } from "./ui";

const ProgressBar = ({ progress }) => <UiProgressBar value={progress} />;

export default ProgressBar;
